<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->

<div class="map_options">
  @if (isVisible()) {
    @if (isDriverHome()) {
      <ul class="top">
        <li (click)="showHeatFlashMap()">
          <figure id="FlagHeatStepDriver">
            @if (!isHeatFlagMap()) {
              <img [src]="assetsConst.flag" alt="globe" />
            } @else {
              <img [src]="assetsConst.flash" alt="globe" />
            }
          </figure>
        </li>
      </ul>

      @if (driverHomeCoords && driverHomeCoords.lat && driverHomeCoords.lng) {
        <ul class="bottom bg_primary" (click)="btn_showDirection()">
          <li>
            <figure>
              <img [src]="assetsConst.directionMap" alt="lights" />
            </figure>
          </li>
        </ul>
      }
    } @else {
      <ul class="top">
        <li (click)="auctions().length > 0 ? showEnquiries() : null">
          <figure style="cursor: pointer">
            <img [src]="assetsConst.noteCountIcon" alt="globe" />
            <figcaption>{{ auctions().length }}</figcaption>
          </figure>
        </li>
      </ul>
      <ul class="bottom bg_primary">
        @if (sos()) {
          @if (user && user.default_region.admin_phone !== '') {
            <a [href]="'tel:' + (user?.default_region.admin_phone || '')">
              <li>
                <figure>
                  <img [src]="assetsConst.callAdmin" alt="lights" />
                </figure>
              </li>
            </a>
          }
          @if (showSoS()) {
            <li (click)="btn_show()">
              <figure>
                <img [src]="assetsConst.adminsos" alt="lights" />
              </figure>
            </li>
          }
        }

        @if (dataWidget) {
          <li (click)="btn_sos()">
            <figure><img [src]="assetsConst.sos" alt="lights" /></figure>
          </li>
          <li (click)="onMarkerClick()">
            <figure><img [src]="assetsConst.directionMap" alt="gps" /></figure>
          </li>
        }
      </ul>
    }
  }
  @if (accessToken()) {
    <logibids-driver-active-toggle />
    <ul class="bottom bg_primary_ai">
      <li (click)="openAI()" class="cursor-pointer">
        <figure><img [src]="assetsConst.voicenote" alt="voicenote" /></figure>
      </li>
    </ul>
  }
</div>
